/* eslint-disable new-cap */
import Phaser from 'phaser';
import AudioPlayer from '../library/AudioPlayer';
import BasicSprite from '../objects/BasicSprite';
import Planet from '../objects/MainMenu/Planet';
import PlayButton from '../objects/MainMenu/PlayButton';
import Title from '../objects/MainMenu/Title';
import SoundButton from '../objects/SoundButton';
import StarField from '../objects/StarField';
import DoorScene from './DoorScene';
import LevelSelect from './LevelSelect';
import gameData from '../gameData';
import Game from './Game';

export default class MainMenu extends Phaser.Scene {
  static get KEY() {return 'MainMenu';}

  create() {
    this.background = new BasicSprite(this, this.scale.width * .5, this.scale.height * .5, 'bg1');
    this.add.existing(this.background);
    this.starField = new StarField(this);

    this.title = new Title(this);
    this.planet = new Planet(this);
    this.playButton = new PlayButton(this);
    const button = this.playButton.Button();
    button.setInteractive();
    button.once('pointerdown', () => this.playButtonPressed());

    this.soundButton = new SoundButton(this, this.scale.width - 60, 60);
  }

  playButtonPressed() {
    AudioPlayer.PlaySound(this, AudioPlayer.sounds.CLICK);
    this.playButton.Button().disableInteractive();
    this.soundButton.button.button.disableInteractive();
    this.planet.AnimateOut();
    this.title.AnimateOut();
    this.playButton.AnimateOut();

    this.game.loadLevelSelect = this.loadLevelSelect;

    this.time.addEvent({ callback: () => {this.closeDoors();}, delay: 2200 });
  }

  closeDoors() {
    if (gameData.config.showOptions) {
      this.scene.get(DoorScene.KEY).changeScene(MainMenu.KEY, LevelSelect.KEY);
    }
    else {
      gameData.countBy = gameData.config.countBy;
      this.scene.get(DoorScene.KEY).changeScene(MainMenu.KEY, Game.KEY);
    }
  }

  update() {
    this.title.Update();
    this.planet.Update();
  }
}